var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-medical"},[_c('div',{staticClass:"medical-cont"},[_c('div',[_c('medicalLeft',{on:{"leftNavTab":_vm.leftNavTab}})],1),_c('div',{staticClass:"medical-wrapper"},[_c('div',{staticClass:"wrapper-info"},[_c('medicalTable',{ref:"medical_table"})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }